import React from "react";

const AppML_Case_Shippers = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Shippers</h1>
      <p>This is the AppML Case Shippers page content.</p>
    </div>
  );
};

export default AppML_Case_Shippers;
